module.exports = __webpack_public_path__ + "media/images/landing_page/2023/main_home_image_sm-b380f4f972fa994add62d55d08ce009d.webp";